import { THEME_DEFAULTS } from 'common/constants/theme';
import { themeAgent } from 'common/utils/theme';
import { darkenLess } from 'common/utils/colors';
import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { merge, set, get } from 'lodash';
const buildTheme = customizations => {
  let ret;
  if (customizations) {
    const typography = { fontFamily: customizations.primaryFont }; // Necessary on first createMuiTheme.
    let theme = createTheme(adaptV4Theme(merge({}, THEME_DEFAULTS, { typography })));
    theme = themeAgent(theme, customizations);
    // defaulting the button primary and payment background color (palette.secondary.main) these pull in all the theme colors we have
    const {
      buttonPrimary = THEME_DEFAULTS.button.primary.main,
      paymentBackgroundColor = THEME_DEFAULTS.button.primary.main,
    } = themeUpdates(customizations);
    // contained secondary hover was inheriting some wild blue color, this ensures its just a darker version of the same color
    set(theme, 'overrides.MuiButton.containedSecondary[&:hover].backgroundColor', darkenLess(get(theme, 'palette.secondary.main')));
    // update the theme to make sure the button primary is updated to the customized color so we don't get the blue
    set(theme, 'button.primary.main', buttonPrimary);
    // update the theme palette secondary main color so that it will update in the payment flow to be more branded
    set(theme, 'palette.secondary.main', paymentBackgroundColor);
    theme = createTheme(adaptV4Theme(theme));
    ret = { theme, customizations };
  } else {
    ret = { theme: createTheme(adaptV4Theme(THEME_DEFAULTS)) };
  }
  return ret;
};

const themeUpdates = ({ layoutName = 'default', secondaryThemeColor }) => {
  let buttonPrimary;
  let paymentBackgroundColor;
  // this is why I wanted to move the theme colors to common
  switch (layoutName) {
    case 'wilderness2':
      buttonPrimary = '#FF6E00';
      paymentBackgroundColor = '#FF6E00';
      break;
    case 'yellowZebra':
      buttonPrimary = '#FFC72A';
      paymentBackgroundColor = '#000000';
      break;
    case 'jacada':
      buttonPrimary = secondaryThemeColor ?? '#C1AA7F';
      paymentBackgroundColor = secondaryThemeColor ?? '#C1AA7F';
      break;
    default:
      buttonPrimary = secondaryThemeColor ?? undefined;
      paymentBackgroundColor = secondaryThemeColor ?? undefined;
      break;
  }
  return {
    buttonPrimary,
    paymentBackgroundColor,
  };
};

export { themeUpdates, buildTheme };
